angular.
module("dx.webapp.wordGap").
controller("DxWordGapCorrectAnswersController", function WordGapCorrectAnswersController(
	$scope
) {
	"use strict";

	var self = this;

	self.blanks = [];

	$scope.$watch("vm.question", function bindBlanks() {
		if (!self.question) {
			return;
		}

		self.blanks = [];
		var virtualDOM = angular.element("<div></div>");
		virtualDOM.append(self.question.bodyHTML);

		virtualDOM.find("span[dx-wg-id]").each(function eachElement(i, e) {
			var element = angular.element(e);
			var guid = element.attr("dx-wg-id");

			self.question.blanks.forEach(function forEach(blank) {
				if (blank.guid === guid) {
					self.blanks.push(blank);
				}
			});
		});
	});
});
